// Mock data for Arikone Digital Marketing Agency

export const services = [
  {
    id: 1,
    title: "Digital Marketing",
    description: "Comprehensive digital strategies to boost your online presence and drive measurable results.",
    icon: "TrendingUp",
    features: ["SEO Optimization", "Content Strategy", "Analytics & Reporting", "Campaign Management"]
  },
  {
    id: 2,
    title: "Social Media Marketing",
    description: "Engage your audience across all platforms with compelling content and strategic campaigns.",
    icon: "Share2",
    features: ["Content Creation", "Community Management", "Influencer Marketing", "Social Analytics"]
  },
  {
    id: 3,
    title: "Performance Ads",
    description: "Data-driven advertising campaigns that maximize ROI and deliver targeted results.",
    icon: "Target",
    features: ["Google Ads", "Facebook Ads", "Instagram Ads", "Retargeting Campaigns"]
  },
  {
    id: 4,
    title: "Website Development",
    description: "Modern, responsive websites that convert visitors into customers.",
    icon: "Code",
    features: ["Custom Design", "Responsive Layout", "E-commerce Integration", "Performance Optimization"]
  },
  {
    id: 5,
    title: "Branding & Creative Design",
    description: "Create memorable brand identities that resonate with your target audience.",
    icon: "Palette",
    features: ["Logo Design", "Brand Guidelines", "Marketing Collateral", "Visual Identity"]
  },
  {
    id: 6,
    title: "Lead Generation",
    description: "Strategic campaigns designed to attract and convert high-quality leads.",
    icon: "Users",
    features: ["Landing Pages", "Email Marketing", "Lead Nurturing", "Conversion Optimization"]
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Luxe Salon & Spa",
    category: "Salon",
    description: "Complete digital transformation including website redesign, social media campaigns, and local SEO.",
    results: "250% increase in bookings within 6 months",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80"
  },
  {
    id: 2,
    title: "Prime Realty Group",
    category: "Real Estate",
    description: "Strategic branding and performance ads campaign for luxury property sales.",
    results: "₹50Cr+ property sales generated",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    id: 3,
    title: "Wanderlust Travels",
    category: "Travel",
    description: "Social media marketing and influencer partnerships for travel packages.",
    results: "180% growth in tour bookings",
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&q=80"
  },
  {
    id: 4,
    title: "Elite Coaching Academy",
    category: "Coaching",
    description: "Lead generation campaigns and content marketing for student enrollment.",
    results: "500+ new student enrollments",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80"
  },
  {
    id: 5,
    title: "Dr. Sharma - Health Coach",
    category: "Personal Branding",
    description: "Personal brand building through content creation and social media strategy.",
    results: "100K+ followers across platforms",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80"
  },
  {
    id: 6,
    title: "EcoLife Products",
    category: "Product Branding",
    description: "Complete brand identity, packaging design, and digital marketing launch.",
    results: "₹1Cr+ revenue in first year",
    image: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=800&q=80"
  },
  {
    id: 7,
    title: "High Blue Travels",
    category: "Travel & Hospitality",
    description: "Website design and branding for a trusted travel partner specializing in safe, affordable transportation and tour packages.",
    results: "1000+ Happy Trips, 4.9/5 Rating",
    image: "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&q=80",
    link: "https://www.highbluetravels.in"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Rahul Sharma",
    role: "Founder & CEO",
    bio: "15+ years of experience in digital marketing and brand strategy.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80",
    social: {
      linkedin: "#",
      twitter: "#",
      email: "rahul@arikone.com"
    }
  },
  {
    id: 2,
    name: "Priya Verma",
    role: "Creative Director",
    bio: "Award-winning designer specializing in brand identity and visual storytelling.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&q=80",
    social: {
      linkedin: "#",
      twitter: "#",
      email: "priya@arikone.com"
    }
  },
  {
    id: 3,
    name: "Arjun Mehta",
    role: "Head of Digital Strategy",
    bio: "Performance marketing expert with proven track record in ROI optimization.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80",
    social: {
      linkedin: "#",
      twitter: "#",
      email: "arjun@arikone.com"
    }
  },
  {
    id: 4,
    name: "Sneha Kapoor",
    role: "Social Media Manager",
    bio: "Social media strategist who creates engaging campaigns that convert.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80",
    social: {
      linkedin: "#",
      twitter: "#",
      email: "sneha@arikone.com"
    }
  }
];

export const stats = [
  { label: "Happy Clients", value: "150+" },
  { label: "Projects Completed", value: "500+" },
  { label: "Years of Experience", value: "15+" },
  { label: "Team Members", value: "25+" }
];

export const testimonials = [
  {
    id: 1,
    name: "Amit Patel",
    company: "Luxe Salon",
    text: "Arikone transformed our online presence completely. Our bookings have tripled!",
    rating: 5
  },
  {
    id: 2,
    name: "Neha Gupta",
    company: "Prime Realty",
    text: "Professional team with exceptional results. Highly recommend their services.",
    rating: 5
  },
  {
    id: 3,
    name: "Vikram Singh",
    company: "Wanderlust Travels",
    text: "The ROI on our campaigns exceeded all expectations. True marketing partners.",
    rating: 5
  }
];

export const companyInfo = {
  name: "Arikone",
  tagline: "Empowering Your Brand to Thrive",
  description: "Arikone: Empowering your brand to thrive. As your dedicated partner in growth, we deliver comprehensive branding strategies that elevate your business. Located in Noida, and serving Delhi and India, we offer strategic promotion and creative content designed to deeply connect you with your audience. With Arikone, you can focus on your core strengths, building your business with confidence, while we expertly craft your brand's success story.",
  address: "Jagriti palace, opp. Bikanerwala, Noida Sector 18, Atta Market, Pocket E, Sector 27, Noida, Uttar Pradesh 201301",
  phone: "096955 35755",
  email: "info@arikone.com",
  hours: "Open · Closes 7 pm",
  serviceAreas: "Noida, Delhi, and India"
};